import { default as _91_46_46_46params_93SP621jPouSMeta } from "/app/pages/boxes/detail/[...params].vue?macro=true";
import { default as listU8FNHhWnKCMeta } from "/app/pages/boxes/list.vue?macro=true";
import { default as replacezNSS3yGbvnMeta } from "/app/pages/boxes/replace.vue?macro=true";
import { default as review1EkQgSYUDpMeta } from "/app/pages/boxes/review.vue?macro=true";
import { default as errorsjvBXed0SCjMeta } from "/app/pages/coupon/list/errors.vue?macro=true";
import { default as indexocypLVSIx6Meta } from "/app/pages/coupon/list/index.vue?macro=true";
import { default as _91_46_46_46params_93SL37a83GRmMeta } from "/app/pages/hints/detail/[...params].vue?macro=true";
import { default as listxEdTxBrggQMeta } from "/app/pages/hints/list.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as _91_46_46_46params_93Eip2MX905iMeta } from "/app/pages/merchants/detail/[...params].vue?macro=true";
import { default as listc0xku7K9tPMeta } from "/app/pages/merchants/list.vue?macro=true";
import { default as _91id_93vjnPV9FcxuMeta } from "/app/pages/settings/currency/[id].vue?macro=true";
import { default as index11eXGkSJBcMeta } from "/app/pages/settings/index.vue?macro=true";
import { default as _91id_93gK7B1UI1PKMeta } from "/app/pages/sites/detail/[id].vue?macro=true";
import { default as listJupnfCG6ZeMeta } from "/app/pages/sites/list.vue?macro=true";
import { default as trackingDLZqIwXG01Meta } from "/app/pages/tracking.vue?macro=true";
import { default as indexnq54o81oozMeta } from "/app/pages/users/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46params_93SP621jPouSMeta?.name ?? "boxes-detail-params",
    path: _91_46_46_46params_93SP621jPouSMeta?.path ?? "/boxes/detail/:params(.*)*",
    meta: _91_46_46_46params_93SP621jPouSMeta || {},
    alias: _91_46_46_46params_93SP621jPouSMeta?.alias || [],
    redirect: _91_46_46_46params_93SP621jPouSMeta?.redirect,
    component: () => import("/app/pages/boxes/detail/[...params].vue").then(m => m.default || m)
  },
  {
    name: listU8FNHhWnKCMeta?.name ?? "boxes-list",
    path: listU8FNHhWnKCMeta?.path ?? "/boxes/list",
    meta: listU8FNHhWnKCMeta || {},
    alias: listU8FNHhWnKCMeta?.alias || [],
    redirect: listU8FNHhWnKCMeta?.redirect,
    component: () => import("/app/pages/boxes/list.vue").then(m => m.default || m)
  },
  {
    name: replacezNSS3yGbvnMeta?.name ?? "boxes-replace",
    path: replacezNSS3yGbvnMeta?.path ?? "/boxes/replace",
    meta: replacezNSS3yGbvnMeta || {},
    alias: replacezNSS3yGbvnMeta?.alias || [],
    redirect: replacezNSS3yGbvnMeta?.redirect,
    component: () => import("/app/pages/boxes/replace.vue").then(m => m.default || m)
  },
  {
    name: review1EkQgSYUDpMeta?.name ?? "boxes-review",
    path: review1EkQgSYUDpMeta?.path ?? "/boxes/review",
    meta: review1EkQgSYUDpMeta || {},
    alias: review1EkQgSYUDpMeta?.alias || [],
    redirect: review1EkQgSYUDpMeta?.redirect,
    component: () => import("/app/pages/boxes/review.vue").then(m => m.default || m)
  },
  {
    name: errorsjvBXed0SCjMeta?.name ?? "coupon-list-errors",
    path: errorsjvBXed0SCjMeta?.path ?? "/coupon/list/errors",
    meta: errorsjvBXed0SCjMeta || {},
    alias: errorsjvBXed0SCjMeta?.alias || [],
    redirect: errorsjvBXed0SCjMeta?.redirect,
    component: () => import("/app/pages/coupon/list/errors.vue").then(m => m.default || m)
  },
  {
    name: indexocypLVSIx6Meta?.name ?? "coupon-list",
    path: indexocypLVSIx6Meta?.path ?? "/coupon/list",
    meta: indexocypLVSIx6Meta || {},
    alias: indexocypLVSIx6Meta?.alias || [],
    redirect: indexocypLVSIx6Meta?.redirect,
    component: () => import("/app/pages/coupon/list/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46params_93SL37a83GRmMeta?.name ?? "hints-detail-params",
    path: _91_46_46_46params_93SL37a83GRmMeta?.path ?? "/hints/detail/:params(.*)*",
    meta: _91_46_46_46params_93SL37a83GRmMeta || {},
    alias: _91_46_46_46params_93SL37a83GRmMeta?.alias || [],
    redirect: _91_46_46_46params_93SL37a83GRmMeta?.redirect,
    component: () => import("/app/pages/hints/detail/[...params].vue").then(m => m.default || m)
  },
  {
    name: listxEdTxBrggQMeta?.name ?? "hints-list",
    path: listxEdTxBrggQMeta?.path ?? "/hints/list",
    meta: listxEdTxBrggQMeta || {},
    alias: listxEdTxBrggQMeta?.alias || [],
    redirect: listxEdTxBrggQMeta?.redirect,
    component: () => import("/app/pages/hints/list.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login",
    path: loginhHM0vSTW5jMeta?.path ?? "/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46params_93Eip2MX905iMeta?.name ?? "merchants-detail-params",
    path: _91_46_46_46params_93Eip2MX905iMeta?.path ?? "/merchants/detail/:params(.*)*",
    meta: _91_46_46_46params_93Eip2MX905iMeta || {},
    alias: _91_46_46_46params_93Eip2MX905iMeta?.alias || [],
    redirect: _91_46_46_46params_93Eip2MX905iMeta?.redirect,
    component: () => import("/app/pages/merchants/detail/[...params].vue").then(m => m.default || m)
  },
  {
    name: listc0xku7K9tPMeta?.name ?? "merchants-list",
    path: listc0xku7K9tPMeta?.path ?? "/merchants/list",
    meta: listc0xku7K9tPMeta || {},
    alias: listc0xku7K9tPMeta?.alias || [],
    redirect: listc0xku7K9tPMeta?.redirect,
    component: () => import("/app/pages/merchants/list.vue").then(m => m.default || m)
  },
  {
    name: _91id_93vjnPV9FcxuMeta?.name ?? "settings-currency-id",
    path: _91id_93vjnPV9FcxuMeta?.path ?? "/settings/currency/:id()",
    meta: _91id_93vjnPV9FcxuMeta || {},
    alias: _91id_93vjnPV9FcxuMeta?.alias || [],
    redirect: _91id_93vjnPV9FcxuMeta?.redirect,
    component: () => import("/app/pages/settings/currency/[id].vue").then(m => m.default || m)
  },
  {
    name: index11eXGkSJBcMeta?.name ?? "settings",
    path: index11eXGkSJBcMeta?.path ?? "/settings",
    meta: index11eXGkSJBcMeta || {},
    alias: index11eXGkSJBcMeta?.alias || [],
    redirect: index11eXGkSJBcMeta?.redirect,
    component: () => import("/app/pages/settings/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93gK7B1UI1PKMeta?.name ?? "sites-detail-id",
    path: _91id_93gK7B1UI1PKMeta?.path ?? "/sites/detail/:id()",
    meta: _91id_93gK7B1UI1PKMeta || {},
    alias: _91id_93gK7B1UI1PKMeta?.alias || [],
    redirect: _91id_93gK7B1UI1PKMeta?.redirect,
    component: () => import("/app/pages/sites/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: listJupnfCG6ZeMeta?.name ?? "sites-list",
    path: listJupnfCG6ZeMeta?.path ?? "/sites/list",
    meta: listJupnfCG6ZeMeta || {},
    alias: listJupnfCG6ZeMeta?.alias || [],
    redirect: listJupnfCG6ZeMeta?.redirect,
    component: () => import("/app/pages/sites/list.vue").then(m => m.default || m)
  },
  {
    name: trackingDLZqIwXG01Meta?.name ?? "tracking",
    path: trackingDLZqIwXG01Meta?.path ?? "/tracking",
    meta: trackingDLZqIwXG01Meta || {},
    alias: trackingDLZqIwXG01Meta?.alias || [],
    redirect: trackingDLZqIwXG01Meta?.redirect,
    component: () => import("/app/pages/tracking.vue").then(m => m.default || m)
  },
  {
    name: indexnq54o81oozMeta?.name ?? "users",
    path: indexnq54o81oozMeta?.path ?? "/users",
    meta: indexnq54o81oozMeta || {},
    alias: indexnq54o81oozMeta?.alias || [],
    redirect: indexnq54o81oozMeta?.redirect,
    component: () => import("/app/pages/users/index.vue").then(m => m.default || m)
  }
]